import {TimeFrame, timeGroup, TimeGroup} from "@ots-frontend/ots-data";

export type TimeBucketData = {
  values: (number | [number, number] | null)[]
}

export type TimeChartData = {
  titles: string[]
  buckets: Record<string, TimeBucketData>
}

export const getDateFormatterOptions = (timeFrame: TimeFrame): Intl.DateTimeFormatOptions => {
  if (timeFrame === 'HOUR') {
    return {
      month: "2-digit",
      day: "2-digit",
      year: undefined,
      hour: "2-digit",
      hourCycle: "h23",
      minute: "2-digit",
      second: undefined
    }
  } else if (timeFrame === "DAY" || timeFrame === "WEEK") {
    return {
      dateStyle: "medium",
      timeStyle: undefined
    }
  } else {
    return {
      month: "2-digit",
      day: undefined,
      year: "2-digit",
      hour: undefined,
      minute: undefined,
      second: undefined
    }
  }
}

export const getDateFormatterOptionsForTimeGroup = (value: TimeGroup | undefined): Intl.DateTimeFormatOptions => {
  if (!value || value === timeGroup.daily || value === timeGroup.weekly || value === timeGroup.semiMonthly) {
    return {
      dateStyle: "medium",
      timeStyle: undefined
    }
  } else if (value === timeGroup.hourly) {
    return {
      month: "2-digit",
      day: "2-digit",
      year: undefined,
      hour: "2-digit",
      hourCycle: "h23",
      minute: "2-digit",
      second: undefined
    }
  } else {
    return {
      month: "2-digit",
      day: undefined,
      year: "2-digit",
      hour: undefined,
      minute: undefined,
      second: undefined
    }
  }
}
